
import React, { useMemo } from 'react';
import { toast } from 'components/Shared/Toast';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';

import { fetcher } from 'api/client';
import { folderAction, createFolder } from 'api/actions/folders';
import bootbox from 'components/Modals/Bootbox';
import { noop } from 'utils';
import { useContractListDispatch, SET_CURRENT_FOLDER } from 'context/contracts';

function useFolderActions(folder, action, options = {
  returnAsObject: false,
  refetch: noop,
  onOpenModal: noop,
  onUpdateFolder: noop
}) {
  const history = useHistory();
  const dispatch = useContractListDispatch();

  const { mutate: mutateCreateFolder } = useMutation((payload) => fetcher(createFolder(payload)), {
    onSuccess: (actionResult) => {

      dispatch({ type: SET_CURRENT_FOLDER, folder: actionResult, childOf: actionResult.name });

      history.push(`/contracts/list/${actionResult._id}`)

      toast.success(t('validations:messages.successfullyCreated', { context: 'female', entity: t('glossary:folder') }));

      refetch({ refreshFolders: true });
    }, onError: (error) => {
      toast.error(t(`errors.${error.message}`));
    }
  });

  const { refetch, onUpdateFolder } = options;
  const { t } = useTranslation(['translation', 'validations', 'glossary']);

  const { mutate: doFolderAction } = useMutation((data) => fetcher(folderAction(folder._id, data.action, data.payload)));

  const actionList = useMemo(() => {

    const actionListObj = {
      DELETE: {
        faIcon: 'trash',
        label: 'contracts.options.delete',
        shouldShow: () => true,
        onClick: async () => {
          const confirm = await bootbox.confirm(t('contracts.listing.folder_delete_confirm', { replace: { folderName: folder.name } }));
          if (!confirm) return;

          doFolderAction({ action: 'delete' }, {
            onSuccess: () => {
              toast.success(t('validations:messages.successfullyDeleted', { context: 'female', entity: t('glossary:folder') }));
              refetch({ refreshFolders: true })
            }
          });


        },
      },
      CREATE: {
        faIcon: 'trash',
        label: 'contracts.options.delete',
        shouldShow: () => {
          if (action) return true;
          return false
        },
        onClick: async () => {

          const name = await bootbox.prompt(t('contracts.new.folder_name'));

          if (!name) return;

          const newFolder = { name, type: 'contracts', count: 0, recursiveCount: 0 };

          mutateCreateFolder(newFolder);

        },
      },
      RENAME: {
        faIcon: 'pen-square',
        label: 'contracts.options.rename',
        shouldShow: () => true,
        onClick: async () => {
          const oldName = folder.name;
          const newName = await bootbox.prompt({
            title: t('contracts.options.rename_name'),
            value: oldName
          });
          if (newName === oldName) return;
          if (!newName) return; // { success: false, error: 'NameNotProvided' };

          const payload = {
            name: newName
          }

          doFolderAction({ action: 'rename', payload }, {
            onSuccess: () => {

              toast.success(t('validations:messages.successfullyUpdated', { context: 'female', entity: t('glossary:folder') }));
              onUpdateFolder(payload)
            }
          });


        }

      },
    };
    // const filteredActionEntries = Object.entries(actionListObj).filter(([key, action]) => action.shouldShow())
    // console.log({filteredActionEntries})
    const filteredActions = Object.fromEntries(Object.entries(actionListObj).filter(([key, action]) => action.shouldShow()).map(([key, action]) => ([key, { ...action, name: key }])))

    if (options.returnAsObject) {
      if (action) return filteredActions[action]
      return filteredActions
    }

    if (action) return [filteredActions[action]]

    return Object.values(filteredActions)
  }, [options.returnAsObject, action, folder.name, folder._id, doFolderAction, onUpdateFolder]);

  // useEffect(() => {
  //   setAvailableActions(actionList);
  // }, [actionList]);

  return actionList;
}

export default useFolderActions;